import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import Checkbox from 'js/components/Forms/Checkbox';
import { Icon } from 'js/components';
import { isScoredType } from 'js/utils/question-set';
import { getQuestionMeta } from 'js/utils/questions';
import styles from './RubricQuestionPickerModal.module.scss';

export default function QuestionOptionCard({
  question,
  checked,
  onToggle,
  onAddSource,
  pickerMode = 'addQuestions',
}) {
  const isAddSourceMode = pickerMode === 'addSource';
  const questionType = question?.type ?? question?.question_type;
  const selectable = useMemo(() => isScoredType(questionType), [questionType]);
  const typeMeta = getQuestionMeta(questionType);
  const { Tag, props } = isAddSourceMode
    ? {
        Tag: Button,
        props: {
          type: 'button',
          color: 'primary',
          onClick: onAddSource,
          disabled: !selectable,
        },
      }
    : { Tag: 'div', props: {} };

  return (
    <Tag
      {...props}
      className={classNames(styles['picker-question-item'], {
        [styles['picker-question-item-disabled']]: !selectable,
      })}
    >
      <span className={styles['picker-question-subtext']}>
        {question.question_set_key} / {question.key}
        {typeMeta.name && typeMeta.icon ? (
          <>
            {' · '}
            <span className={styles['picker-question-type-inline']}>
              <Icon
                icon={typeMeta.icon}
                className={styles['picker-question-type-icon']}
              />
              {typeMeta.name}
            </span>
          </>
        ) : null}
        {!selectable ? ' · Not scored' : ''}
      </span>
      {isAddSourceMode ? (
        <>{question.question_text || question.key}</>
      ) : (
        <Checkbox checked={checked} onChange={onToggle} disabled={!selectable}>
          {question.question_text || question.key}
        </Checkbox>
      )}
    </Tag>
  );
}
